import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import Style from './style.module.less'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Button, Table } from 'hljd'
import store from '../store'
import column from './column'
import ChoseSetMeal from '../ChoseSetMeal'
import cStyle from '@common/ModalIf/style.module.less'
import { Link } from 'react-router'
import Qrcode from './Qrcode'
import { SHOP_PRODUCTS_PATH } from '@constant'

@observer
export default class extends Component {
  componentDidMount() {
    store.getShowCaseListFn(1)
  }

  handleTableChange(page) {
    store.setPagination(page)
  }

  render() {
    const {
      showCaseList,
      loading,
      pagination,
      isShow,
      hideQrCote,
      showQrCote,
      change_show,
      bigQrCote,
      modalIf
    } = store

    return (
      <div className={Style.showCaseList}>
        <dl className={Style.headBox}>
          <dt>
            推荐橱窗<Link
              style={{ marginLeft: 19, fontSize: 12 }}
              to={'/localMerchant/showCase/caseExample'}
            >
              <QuestionCircleOutlined
                style={{ marginRight: 4, fontSize: 14 }}
              />学习优秀范例，提高橱窗点击
            </Link>
          </dt>

          <dd>
            <Button onMouseOut={hideQrCote} onMouseOver={showQrCote}>
              效果预览
            </Button>
          </dd>

          {bigQrCote && !change_show && <Qrcode />}
        </dl>

        <p className={Style.tip}>
          设置相应橱窗位的关联套餐，让消费者更好的了解你店铺的主打商品
        </p>

        <div style={{ margin: '0 20px' }}>
          <Table
            rowKey={record => record.seat}
            columns={column}
            dataSource={toJS(showCaseList)}
            loading={loading}
            pagination={pagination}
            bordered
            onChange={this.handleTableChange}
          />
        </div>

        {isShow && <ChoseSetMeal />}

        {modalIf.isShow && (
          <div className={cStyle.tipBox} style={{ zIndex: 999 }}>
            <div className={cStyle.tip2}>
              <div className={cStyle.cont}>{modalIf.content}</div>
              <div className={cStyle.btnBox}>
                {modalIf.type1 == 1 && (
                  <button onClick={store.onCancel}>{modalIf.btn1}</button>
                )}
                {modalIf.type1 == 2 && (
                  <span>
                    <button onClick={store.onCancel}>{modalIf.btn1}</button>
                    <button>
                      <Link to={SHOP_PRODUCTS_PATH}>{modalIf.btn2}</Link>
                    </button>
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}
